import { CheckCircle, ContentPasteOffOutlined, PendingActions } from "@mui/icons-material";
import { Typography, Grid, Box } from "@mui/material";
import { access } from "fs";
import { canLaunchSingle, canMakeReferral, canViewAllReports, canViewInsights } from "ft-shared-graphql";
import { Step } from "react-joyride";

export const reportsSteps: Record<string, { label: string; steps: Step[], onSkip?: string }> = {
    reportsMain: {
        label: "Reports",
        onSkip: "reportsPage",
        steps: [
            {
                target: '[data-tour="reports-table"]',
                placement: "center",
                content: "When you run a session their results will be displayed here",
                data: { route: '/dashboard/student/:studentId/sessions', access: canViewAllReports }
            },
            {
                target: '[data-tour="review-session"]',
                content: (<Grid container spacing={1} >
                    <Grid size={12}>
                        <Typography>If you are assigned the student, you will receive an email notification that a report is ready, and they will appear in your actions needed table.</Typography>
                    </Grid>
                    <Grid size={12}>
                        <Typography>The icons mean the following</Typography>

                        <Grid container spacing={1}>
                            <Grid size={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: "column", justifyContent: "center", gap: 1 }}>
                                    <ContentPasteOffOutlined />
                                    <Typography sx={{ fontSize: "smaller" }}>
                                        Nothing to review: either the report hasn't generated,
                                        the session has no answers, or you are not directly
                                        assigned to this student.
                                    </Typography>
                                </Box>                            </Grid>
                            <Grid size={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: "column", justifyContent: "center", gap: 1 }}>
                                    <PendingActions sx={{ color: '#ffc107' }} />
                                    <Typography sx={{ fontSize: "smaller" }}>
                                        This session is unread.
                                    </Typography>
                                </Box>
                            </Grid>
                            <Grid size={4}>
                                <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: "column", justifyContent: "center", gap: 1 }}>
                                    <CheckCircle sx={{ color: '#4caf50' }} />
                                    <Typography sx={{ fontSize: "smaller" }}>
                                        You have reviewed the session.
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>),
                data: { route: '/dashboard/student/:studentId/sessions', access: canViewAllReports }
            },
            {
                target: '[data-tour="reports-table"]',
                content: "There are many ways to review a session, you can click the pending icon for the corresponding session",
                data: { route: '/dashboard/student/:studentId/sessions' }
            },
            {
                target: '[data-tour="view-session"]',
                content: "Or you can view the generated report, and it session will be reviewed automatically",
                data: { route: '/dashboard/student/:studentId/sessions' }
            },
            {
                target: '[data-tour="brief-summary"]',
                content: 'Here you can see a summary of the session. Any troubling keywords/phrases they say will display a "Needs Review" Chip, click the chip to view keywords and phrases.',
                data: { route: '/dashboard/student/:studentId/sessions' }
            },
        ]
    },
    reportTableToolBar: {
        label: "Report's Toolbar",
        steps: [
            {
                target: '[data-tour="launch-report"',
                content: "You can also launch a session from this page",
                data: {
                    route: "/dashboard/student/:studentId/sessions",
                    access: canLaunchSingle
                }
            }, {
                target: '[data-tour="report-referral"',
                content: "If you'd like make a note of outside referral, monitoring in house, or no referral needed click here",
                data: {
                    route: "/dashboard/student/:studentId/sessions",
                    access: canMakeReferral
                }
            },
            {
                target: '[data-tour="summary-notes"',
                content: "View any notes on this child here. As well as see action history",
                data: {
                    route: "/dashboard/student/:studentId/sessions"
                }
            },
            {
                target: '[data-tour="parent-resources"',
                content: "If you'd like to send infomation for parents based on the results click here. You must view the resources before downloading/sending them to the parents",
                data: {
                    route: "/dashboard/student/:studentId/sessions"
                }
            },
            {
                target: '[data-tour="student-info"',
                content: "Click here to view the student's demographic information",
                data: {
                    route: "/dashboard/student/:studentId/sessions"
                }
            },
        ]
    },
    nextSectionInsights: {
        label: "Transition to Insights",
        steps: [
            {
                target: '[data-tour="main-menu"]',
                content: "Now let's take a look at student insights",
                data: {
                    // route: '/dashboard/student/:studentId/sessions', 
                    action: "mainMenu", access: canViewInsights
                }
            },
        ]
    }

}

